import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';

export default function (ComposedComponent, requiresPermission, requiresFeature) {

  class Authenticate extends Component {

    componentWillMount() {
      let user = JSON.parse(localStorage.getItem("user"));
      if (!user) this.props.history.push('/login');
      // if (this.props.isAuthenticated === false) { this.props.history.push('/login') }
      // else this.setState({ ...this.state, loaded: true })
    }

    componentDidMount() {
      let user = JSON.parse(localStorage.getItem("user"));
      if (!user) this.props.history.push('/login');
      // if (this.props.isAuthenticated === false) { this.props.history.push('/login') }
      // else this.setState({ ...this.state, loaded: true })
    }

    // componentWillUpdate(nextProps) {
    //   let user_id = localStorage.getItem("user_id");
    //   if (!user_id) this.props.history.push('/login');
    //   // if (this.props.isAuthenticated === false) this.props.history.push('/login');
    // }

    // checkForFeature() {
    //   const value = requiresFeature.permissionString;
    //   let props = this.props;

    //   if (props.companyFeatures.indexOf(value) === -1) {
    //     this.props.history.push('/');
    //   }
    //   this.setState({ ...this.state, loaded: true })
    // }


    render() {
      if (ComposedComponent) return (<ComposedComponent {...this.props} />);
      // if (ComposedComponent && !requiresPermission) return (<ComposedComponent {...this.props} />);
      // if (ComposedComponent && requiresPermission) return (this.state.loaded ? <ComposedComponent {...this.props} /> : "");
    }
  }

  Authenticate.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
  };

  function mapStateToProps(state) {
    return {
      isAuthenticated: state.userAuthentication.isAuthenticated,

    };
  }

  return connect(mapStateToProps, null)(Authenticate);
}
